export * as dashActionTypes from './dashActionTypes';

export const DASH_EDIT_HISTORY_UNIT_ID = 'dash';
